/**
 * Pricing-tier "Choose package" CTA helper.
 *
 * 1. POSTs a lead with `source: "pricing_tier_cta"` and a placeholder email.
 * 2. Opens WhatsApp with a pre-filled message in a new tab (regardless of
 *    backend status — fail-open UX).
 *
 * Returns: { lead_id, whatsapp_url, ok }
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const WHATSAPP_PHONE = "908508884865";

export async function fireQuickPricingLead({
  serviceLabel,
  serviceSlug,
  tierLabel,
  formattedPrice,
  lang = "tr",
  utm = {},
  referrer = "",
}) {
  const landingPage = typeof window !== "undefined" ? window.location.pathname : "";
  const message = `Pricing tier seçildi: ${tierLabel} paketi (${formattedPrice}/ay) — ${serviceLabel} hakkında detaylı bilgi almak istiyorum.`;
  const waMessage = `Merhaba, ${serviceLabel} ${tierLabel} paketini seçtim (${formattedPrice}/ay). Detaylı bilgi almak istiyorum.`;
  const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(waMessage)}`;

  // Open WhatsApp early (in click handler) to avoid popup blockers
  const waWindow = typeof window !== "undefined"
    ? window.open(whatsappUrl, "_blank", "noopener,noreferrer")
    : null;

  let leadId = null;
  let ok = false;
  try {
    const res = await axios.post(`${API}/leads`, {
      name: `Pricing CTA — ${tierLabel}`,
      email: "pricing-cta@yastikmedya.local",
      phone: "+0000000",
      service: serviceLabel,
      service_slug: serviceSlug || "",
      message,
      lang,
      utm,
      referrer,
      landing_page: landingPage,
      source: "pricing_tier_cta",
    });
    leadId = res?.data?.lead_id || null;
    ok = !!res?.data?.success;
  } catch (e) {
    // Non-blocking: WhatsApp already opened
    // eslint-disable-next-line no-console
    console.warn("Pricing CTA lead failed (WhatsApp still opened):", e?.message);
  }

  // If popup was blocked, fallback to direct nav
  if (!waWindow && typeof window !== "undefined") {
    window.location.href = whatsappUrl;
  }

  return { leadId, whatsappUrl, ok };
}
